<template>
  <v-container>
    <v-row  justify="center">
      <v-col cols="12" md="12">
        <v-container>
          <v-row justify="center">
            <span class="mx-3" style="font-size: 34px; color: #616161"
              >Categorías</span
            >
          </v-row>
          <v-row justify="center" class="mt-n1 mx-2">
            <span style="font-size: 16px; color: #757575"
              >Crea nuevas categorías para clasificar tus productos y ubicarlos
              fácilmente en el master de articulos
            </span>
          </v-row>
          <v-row justify="center">
            <v-col cols="12">
              <v-card outlined>
                <v-data-table
                  v-if="loaded == false"
                  :headers="headers"
                  :items="data"
                  :search="search"
                  dense
                > 
                  <template v-slot:top>
                    <v-toolbar flat>
                      <v-toolbar-title>Categorías</v-toolbar-title>
                      <v-divider class="mx-4" inset vertical></v-divider>
                      <v-spacer> </v-spacer>
                      <v-text-field
                        class="text-xs-center"
                        v-model="search"
                        append-icon="search"
                        label="Buscar"
                        single-line outlined
                        hide-details dense
                      >
                      </v-text-field>  
                      <v-spacer></v-spacer>
                       <v-btn
                            v-if="hasFeature('INV-102')"
                            @click="showDialog()"
                            color="primary"
                            dark
                            class="mb-2"
                          >
                            <v-icon> add </v-icon>
                            Nueva categoría
                          </v-btn>
                    </v-toolbar>
                  </template>
  
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-if="hasFeature('INV-102')"
                          v-bind="attrs"
                          v-on="on"
                          medium
                          color="blue"
                          @click="editItem(item)"
                        >
                          mdi-pencil
                        </v-icon>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:no-data>
                    <v-row justify="center" class="pt-10">
                      <v-icon size="80px">token</v-icon>
                    </v-row>
                    <v-row justify="center" class="pb-6"> No hay datos </v-row>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
               <v-dialog v-model="dialog" max-width="30%">
                        <v-card height="auto">
                          <v-row no-gutters justify="center">
                            <v-card-title class="text-center">
                              <span class="text-h5 text-center"
                                >{{ formTitle }} {{ newItemName }}</span
                              >
                            </v-card-title>
                          </v-row>
  
                          <v-card-text>
                            <v-row justify="center">
                              <v-col cols="12" md="12">
                                <v-container>
                                  <v-row justify="start">
                                    <v-col cols="12" md="12">
                                      <v-row justify="center" no-gutters>
                                        <v-col cols="10">
                                          <v-row no-gutters>
                                            <v-text-field
                                              v-model="editedItem.name"
                                              label="Nombre"
                                              outlined
                                              dense
                                            ></v-text-field>
                                          </v-row>
                                          <v-row no-gutters>
                                            <v-textarea
                                              v-model="editedItem.note"
                                              label="Descripcion"
                                              outlined
                                              dense
                                            ></v-textarea>
                                          </v-row>
                                          <v-row no-gutters>
                                           <v-switch v-if="editedIndex>-1"
                                           v-model="editedItem.active"
                                           label="Activa"
                                           ></v-switch>
                                          </v-row>
                                        </v-col>
                                      </v-row>
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-col>
                            </v-row>
                          </v-card-text>
  
                          <v-card-actions class="m">
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="close">
                              Cancelar
                            </v-btn>
                            <v-btn outlined color="blue darken-1" @click="save">
                              Guardar
                            </v-btn>
                            <v-spacer></v-spacer>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
        </v-container>
      </v-col></v-row
    >
  </v-container>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    search: "",
    disable: false,
    dialogDelete: false,
    loaded: false,
    itemsletiant: [],
    newItemName: "",
    parentId: null,
    headers: [
      {
        text: "Codigo",
        align: "start",
        sortable: false,
        value: "id",
      },
      { text: "Nombre", value: "name" },
      { text: "Status", value: "estatus_description", sortable: false },
      { text: "Actions", value: "actions", sortable: false },
    ],
    data: [],
    editedIndex: -1,
    editedItem: {
      name: "",
    },
    defaultItem: {
      name: "",
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nueva categoria" : "Editar categoria";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  mounted() {
    //  this.initialize();
  },
  created() {
    this.initialize();
  },

  methods: {
    async load_categories() {
      const resultCategories = await this.api_Post("inventory/GetCategories", {
        filters: 'WHERE PARENT_CATEGORY_ID ISNULL',
      });

      this.data = await resultCategories.json();
    },

    showDialog() {
      this.dialog = true;
    },

    async initialize() {
      this.loaded = true;
      this.load_categories();
      this.loaded = false;
    },
    async updateState(item) {
      let data = {
        id: item.id,
        active: item.active,
      };

      const responseRequest = await this.api_Post(
        "inventory/categories/updateState",
        data
      );

      if (responseRequest.status == 200) {
        // this.$toast.success("agregado con exito!");
        this.dialog = false;
      } else {
        this.$toast.error("error!");
      }
    },
    addItem(item) {
      this.disable = true;
      this.itemsletiant = [];
      let index = this.data.indexOf(item);

      this.editedItem = Object.assign({}, item);

      this.parentId = this.editedItem.id;
      this.newItemName = this.editedItem.name;
      this.editedItem.name = "";
      this.editedItem.note = "";

      this.dialog = true;
    },
    editItem(item) {
      //this.parentId = null;

      this.disable = true;
      this.newItemName = "";
      this.itemsletiant = [];
      this.editedIndex = 1;

      this.editedItem = Object.assign({}, item);

      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.data.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.data.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.disable = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      this.disable = false;
      if( this.editedItem.name.length<1)
      {
        this.$toast.error("el nombre es obligatorio");
        return;
      }
      if (this.editedIndex > -1) {
        let data = {
          id: this.editedItem.id,
          parent_category_id: null,
          image_url: "",
          name: this.editedItem.name,
          note: this.editedItem.note == undefined ? null : this.editedItem.note,
          active: this.editedItem.active,
          catelogue_id:null
        };
        const responseRequest = await this.api_Put(
          "inventory/categories",
          data
        );

        if (responseRequest.status == 200) {
          this.load_categories();

          // this.$toast.success("agregado con exito!");
          this.dialog = false;
        } else {
          this.$toast.error("error al agregar!");
        }
      } else {
        let data = {
          parent_category_id: null,
          image_url: "",
          name: this.editedItem.name,
          note: this.editedItem.note == undefined ? null : this.editedItem.note,
          active: true,
          catelogue_id:null
        };
        const responseRequest = await this.api_Post(
          "inventory/categories",
          data
        );

        if (responseRequest.status == 200) {
          this.load_categories();

          // this.$toast.success("agregado con exito!");
          this.dialog = false;
        } else {
          this.$toast.error("error al agregar!");
        }
      }

      this.close();
    },
  },
};
</script>
